/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 TeamPage = {
    loadMembers: function(e) {
        var button = $(this);

        var id = button.data('id')
        var department = button.data('department')

        if (button.hasClass('disabled')) {
            return false;
        }

        button.addClass('disabled');

        $("#team-members-list-"+department).animate({'opacity': 0.5});

        $.ajax({
            url: '/a/teamPage/loadMembers',
            type: 'POST',
            dataType: 'json',
            data: {'id': id},
        }).done(function(data) {
            button.removeClass('disabled');

            $("#team-members-list-"+department).fadeIn().animate({'opacity': 1}).find('.row').html(data.html);
        });
    },
    profilePrev: false,
    profileNext: false,
    loadProfile: function() {
        var box = $(this).closest('.box-member');
        var html = box.find('.profile-html').html();

        TeamPage.profilePrev = box.prev();
        TeamPage.profileNext = box.next();

        $(".team-profile").html(html);
    },
    loadProfilePrev: function() {
        var box = TeamPage.profilePrev;

        if (box.length > 0) {
            var html = box.find('.profile-html').html();

            TeamPage.profilePrev = box.prev();
            TeamPage.profileNext = box.next();

            $(".team-profile").html(html);
        }
    },
    loadProfileNext: function() {
        var box = TeamPage.profileNext;

        if (box.length > 0) {
            var html = box.find('.profile-html').html();

            TeamPage.profilePrev = box.prev();
            TeamPage.profileNext = box.next();

            $(".team-profile").html(html);
        }
    },
    init: function() {
        $(".team-role").on('click', TeamPage.loadMembers);
        $(document).on('click', '.team-member-load-profile', TeamPage.loadProfile);
        $(document).on('click', '.team-profile-previous', TeamPage.loadProfilePrev);
        $(document).on('click', '.team-profile-next', TeamPage.loadProfileNext);
    }
};
